import RsaFatturazione from "..";

const routes = [
    { name: "RsaFatturazioneListPage", path: "/rsafatturazione", component: RsaFatturazione.RsaFatturazioneListPage, meta: { title: "R.S.A. - Fatture" } },
    { name: "RsaFatturazioneDettaglioListPage", path: "/rsafatturazione/dettagli", component: RsaFatturazione.RsaFatturazioneDettaglioListPage, meta: { title: "R.S.A. - Fatture" } },
    // { name: "StrutturaView", path: "/struttura/view/:id", component: Strutture.StrutturaView, meta: { title: "strutture.lblTitle" } },
    // { name: "StrutturaEdit", path: "/struttura/edit/:id", component: Strutture.StrutturaEdit, meta: { title: "strutture.lblTitle" } },
];

export default routes;
